import { appInjector } from '../app-injector';
import { RoleType } from '../constants-types/Enums';
import { InitDataService } from '../system-services/InitData/InitData.service';

export function hasPermissionLevel(permissionLevel: RoleType): MethodDecorator {
    return function (_target, _propertyKey, descriptor: PropertyDescriptor) {
        const fn = descriptor.value;
        descriptor.value = function (...args: any[]) {
            const initData = appInjector().get(InitDataService);

            if (!initData.hasPermissionLevelOrAbove(permissionLevel)) {
                return new Promise((_resolve, reject) => {
                    reject();
                });
            }

            return fn.apply(this, args);
        };
    };
}
